export default {"src":"/newStatic/_next/static/media/app-store-icon.e8c4a184.svg","height":20,"width":20};